import React from 'react';
import HeroSection from '../sections/heroSection';
import Statistics from '../sections/statistics';
import TextQuoteWithImage from '../sections/textQuoteWithImage';
import IconsWithHeadingText from '../sections/iconsWithHeadingText';
import HeadingWithGrid from '../sections/headingWithGrid';
import Services from '../sections/services';

const ShopifyPlus = () => {
    const body = document.body;
    body.classList = 'template-shopify-plus'; 
    const content = require('../jsons/shopify-plus.js').default;

    return(
        <div className="innerWrapper">            
            {content.heroSection.enable && 
                <HeroSection data={ content.heroSection }/>
            } 
            {content.statistics.enable && 
                <Statistics data={ content.statistics}/>
            } 
            <div className="sections whiteBg">
                {content.textQuoteWithImage.enable && 
                    <TextQuoteWithImage data={content.textQuoteWithImage} />
                }
                {content.iconsWithHeadingText.enable && 
                    <IconsWithHeadingText data={content.iconsWithHeadingText} />
                }               
                {content.headingWithGrid.enable && 
                    <HeadingWithGrid data={content.headingWithGrid} />
                } 
                {content.services.enable && 
                    <Services data={content.services} />
                }                
            </div>
        </div>
    )
}

export default ShopifyPlus;